export function setupRouteFade(reducedMotion: MediaQueryList) {
  const root = document.documentElement;
  let navigating = false;
  let timer = 0;

  const reveal = () => {
    root.classList.remove('route-leaving');
    root.classList.add('route-entering');
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('route-ready')));
    window.clearTimeout(timer);
    timer = window.setTimeout(() => root.classList.remove('route-entering'), 240);
    navigating = false;
  };

  const isEligibleAnchor = (anchor: HTMLAnchorElement) => {
    if (anchor.target === '_blank' || anchor.hasAttribute('download') || anchor.dataset.routeInstant !== undefined) return false;
    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return false;
    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return false;
    return true;
  };

  const onClick = (event: MouseEvent) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || navigating) return;
    const target = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!(target instanceof HTMLAnchorElement) || !isEligibleAnchor(target)) return;
    event.preventDefault();
    navigating = true;
    root.classList.remove('route-ready', 'route-entering');
    root.classList.add('route-leaving');
    window.dispatchEvent(new CustomEvent('kbuild:route-leave'));
    const href = target.href;
    timer = window.setTimeout(() => window.location.assign(href), reducedMotion.matches ? 0 : 140);
  };

  reveal();
  document.addEventListener('click', onClick, true);
  window.addEventListener('pageshow', reveal);

  return () => {
    document.removeEventListener('click', onClick, true);
    window.removeEventListener('pageshow', reveal);
    window.clearTimeout(timer);
  };
}
